{
  "en": {
    "task": {
      "actions": {
        "create": "Task",
        "update": "Edit task"
      },
      "attributes": {
        "assignments_count": "Assignments",
        "category": "Category",
        "created_at": "Created",
        "description": "Description",
        "title": "Title",
        "units": "Units"
      },
      "categories": {
        "confirmation": "Confirmation",
        "upload": "Upload"
      },
      "labels": {
        "no_tasks": "No tasks for this project yet.",
        "required": "This field is required",
        "units_required": "Select at least one unit"
      },
      "toasts": {
        "create": "Task created",
        "delete": "Task deleted",
        "update": "Task updated"
      }
    }
  }
}
